// extracted by mini-css-extract-plugin
export default {"asset-info":"styles__asset-info--MXOYu","info-dot":"styles__info-dot--LICgJ"};